var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.price > 0)?_c('span',[_vm._v(" € "+_vm._s((Math.round((_vm.price * _vm.amount + Number.EPSILON) * 100) / 100) .toFixed(2) .replace('.', ','))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }